


























































import { defineComponent, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter } from "@/hooks/use-router";
import WalletItem from "./WalletItem.vue";

export default defineComponent({
  components: { WalletItem },
  props: {
    createOnly: Boolean
  },
  setup() {
    const { store } = useVuex();
    const router = useRouter();

    const wallet = computed(() => store.getters.Wallet.wallet);
    const wallets = computed(() =>
      (store.state.Wallet.wallets || []).sort((a, b) => {
        if (a.address === wallet.value?.address) return -100;
        return a.name > b.name ? 0 : -1;
      })
    );

    const close = () => {
      const redirect = router.currentRoute.query.redirect;
      if (redirect) {
        router.push(redirect as string);
      } else router.push("?");
    };

    const setWallet = store.commit.Wallet.setWallet;

    const openHelp = () => {
      store.commit.Help.setHelpOpen(true);
      close();
    };

    return {
      wallet,
      wallets,
      openHelp,
      setWallet,
      close
    };
  }
});
